import { useMemo, useState } from 'react';
import { STORAGE_KEY } from '../../config';
import { TRACKING_ICON_INITIAL_FILTER, TrackingIconFilter } from '../models';

const getStoredFilter = (
  initialFilter: TrackingIconFilter
): TrackingIconFilter => {
  const raw = localStorage.getItem(STORAGE_KEY.trackingIconsFilters);
  if (!raw) return initialFilter;

  try {
    const stored = JSON.parse(raw) as Partial<TrackingIconFilter>;
    return {
      name: typeof stored.name === 'string' ? stored.name : initialFilter.name,
      enabled:
        stored.enabled === 'true' || stored.enabled === 'false'
          ? stored.enabled
          : initialFilter.enabled,
      isDefault:
        stored.isDefault === 'true' || stored.isDefault === 'false'
          ? stored.isDefault
          : initialFilter.isDefault,
    };
  } catch {
    return initialFilter;
  }
};

const useTrackingIconFilter = () => {
  const initialFilter: TrackingIconFilter = useMemo(
    () => TRACKING_ICON_INITIAL_FILTER,
    []
  );

  const [filter, setFilter] = useState<TrackingIconFilter>(() =>
    getStoredFilter(initialFilter)
  );

  return {
    initialFilter,
    filter,
    setFilter,
  };
};

export default useTrackingIconFilter;
